import React, { useState, useEffect } from 'react'
import scrapbook from '../../images/scrapbook.png'
import { AppBar, Typography, Button, Toolbar, Avatar } from '@material-ui/core'
import decode from 'jwt-decode'

import useStyles from './styles'
import { useDispatch } from 'react-redux'
import { useHistory, Link, useLocation } from 'react-router-dom'
import * as actionType from '../../constants/actionTypes'

//TO CAPTALIZE
import startcase from 'lodash.startcase'
const capitalizeWord = (value) => startcase(value.toLowerCase())
//
const Navbar = () => {
	const classes = useStyles()
	const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
	// console.log('user is', user)
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()
	const logout = () => {
		dispatch({ type: actionType.LOGOUT })
		setUser(null)
		history.push('/auth')
	}

	useEffect(() => {
		const token = user?.token

		//JWT
		if (token) {
			const decodedToken = decode(token)

			if (decodedToken.exp * 1000 < new Date().getTime()) logout()
		}

		setUser(JSON.parse(localStorage.getItem('profile')))
	}, [location])

	return (
		<AppBar className={classes.appBar} position='static' color='inherit'>
			<div className={classes.brandContainer}>
				<Typography
					component={Link}
					to='/'
					className={classes.heading}
					variant='h2'
					align='center'
				>
					<img className={classes.image} src={scrapbook} alt='memories' height='60' />
				</Typography>
			</div>
			<Toolbar className={classes.toolbar}>
				{user?.result ? (
					<div className={classes.profile}>
						<Avatar
							className={classes.purple}
							alt={user?.result.name}
							src={user?.result.imageUrl}
						>
							{user?.result?.name.charAt(0)}
						</Avatar>
						<Typography className={classes.userName} variant='h6'>
							{capitalizeWord(user?.result.name)}
						</Typography>
						<Button
							variant='contained'
							className={classes.logout}
							color='secondary'
							onClick={logout}
						>
							Logout
						</Button>
					</div>
				) : (
					<Button component={Link} to='/auth' exact variant='contained' color='primary'>
						Sign In
					</Button>
				)}
			</Toolbar>
		</AppBar>
	)
}

export default Navbar
